export default __webpack_public_path__ + "static/media/mx-step1.83417ba1.png";